import React from "react";
import { Drawer } from "@material-ui/core";
import { useState, useEffect } from "react";

const DrawerComponent = ({
  open,
  close,

  drawerContent: { title, content, imageUrl, actionText, callback, actionButtonDisabled },
}) => {
  // Lock root component scrolling
  useEffect(() => {
    const rootElement = document.getElementById("root");
    if (open) {
      rootElement.style.overflow = "hidden";
    } else {
      rootElement.style.overflow = "auto";
    }

    // Cleanup function to reset the overflow property when component unmounts
    return () => {
      rootElement.style.overflow = "auto";
    };
  }, [open]);

  return (
    <Drawer
      anchor="bottom"
      open={open}
      PaperProps={{
        style: {
          minHeight: 100,

          width: "100%",
          marginBottom: 0,
        },
        className: "text-center",
      }}
      onBackdropClick={close}
    >
      <>
        <div style={{ textAlign: "left", position: "relative", height: "100%" }}>
          <>
            {imageUrl && (
              <div
                style={{
                  position: "relative",
                  textAlign: "center",
                  background: `url('${imageUrl}') no-repeat center center`,
                  backgroundSize: "cover",
                  minHeight: 250,
                  minWidth: 300,
                }}
              ></div>
            )}
            <div style={{ padding: 20 }}>
              <h2>{title}</h2>
              {content}
            </div>
          </>
          {actionText && (
            <>
              <div
                style={{
                  padding: 10,
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "block",
                    cursor: !actionButtonDisabled && "pointer",
                    width: "95%",
                    margin: "8px auto",
                    height: 46,
                    border: "1px solid #dedede",
                    background: actionButtonDisabled ? "#9c9c9c" : "#0099cc",
                    color: "#fff",
                    borderRadius: 100,
                    fontWeight: "bold",
                    lineHeight: "46px",
                    textAlign: "center",

                    fontSize: 16,
                  }}
                  onClick={!actionButtonDisabled && callback}
                >
                  {actionText}
                </div>
              </div>
            </>
          )}
        </div>
      </>
    </Drawer>
  );
};

export default DrawerComponent;
